export { patchMoment } from './lib/moment-patch';
export * from './lib/i18n.module';
export * from './lib/i18n.service';
export * from './lib/i18n.tokens';
export * from './lib/time-translations';
export * from './lib/phrase-app/phrase-app-editor.service';
export * from './lib/phrase-app/phrase-app-translation.service';
export * from './lib/multilang/multilang-translation.service';
export { TranslatePipe } from './lib/translate.pipe';
